/* eslint-disable no-control-regex */
import * as Yup from 'yup';
import { firstName, lastName, gender, email, dateOfBirth } from 'validation';

export default Yup.object({
  citizenship: Yup.string().required('Required'),
  email,
  gender,
  firstName,
  lastName,
  dateOfBirth
});
